<template>
  <div class="StoryView" :class="{'seen' : seen.includes(this.obj.id)}" v-if="obj">
    <img @dragstart.prevent v-lazy="$RESIZE + obj.videoCover + '&story=1'" class="status" @click="openModal()">
  </div>
  <div class="StoryView" v-else>
    <img @dragstart.prevent src="../assets/story.webp" class="status">
  </div>
</template>
<script>
export default {
  name: 'StoryView',
  props: {
    obj: JSON
  },
  data () {
    return {
      seen: JSON.parse(localStorage.getItem('seen')) || []
    }
  },

  methods: {
    openModal: function () {
      document.getElementById('story-modal-' + this.obj.id).classList.remove('d-none')
      document.getElementById('story-modal-' + this.obj.id).classList.add('d-flex')
      document.getElementById('story-video-' + this.obj.id).play()
    }
  },
  mounted () {
    this.emitter.on('seen', isOpen => { this.seen = JSON.parse(localStorage.getItem('seen')) || [] })
  },
  watch: {}
}
</script>
<style scoped>
.seen{
  border: solid 3px #aaa !important;
}
.StoryView{
  margin:0px 5px;
  border: solid 3px #cb5eee;
  padding: 2px;
  border-radius: 50%;
}
.status{
  height: 110px;
  width: 110px;
  border-radius: 50%;
  object-fit: cover;
}
@media (max-width:1281px) {
  .status{
    height: 110px;
    width: 110px;
  }
}
@media (max-width:1025px) {
  .status{
    height: 100px;
    width: 100px;
  }
}
@media (max-width:768px)  {
  .status{
    height: 90px;
    width: 90px;
  }
}
@media (max-width:480px)  {
  .status{
    height: 80px;
    width: 80px;
  }
}

</style>
